import { render, staticRenderFns } from "./PForm.vue?vue&type=template&id=d16c8e02&scoped=true&"
import script from "./PForm.vue?vue&type=script&lang=ts&"
export * from "./PForm.vue?vue&type=script&lang=ts&"
import style0 from "./PForm.vue?vue&type=style&index=0&id=d16c8e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16c8e02",
  null
  
)

export default component.exports